<template>
  <div class="events-container">
    <div class="events-row" v-if="events !== false">
      <div class="btn left" @click="setEvent(evtIndex + 1)" :class="{ disabled: evtIndex === totalEvents - 1 }"><i class="fa fa-arrow-left"></i></div>
      <div class="events-data" v-if="!isLoading">
        <div class="cell"><div class="value">{{formatTime(cEvt)}}</div></div>
        <div class="cell"><div class="value">{{cEvt.data}}</div></div>
        <div class="cell">
          <div class="value">
            <div class="btn-group" style="padding-top: 5px;" aria-label="" role="group">
              <button type="button" class="btn btn-sm" @click.stop="processEvent" :class="{'btn-success': !cEvt.is_processed}" style="margin-right: 5px;">
                <i class="fa fa-check-square" aria-hidden="true"></i>
                <span v-if="!cEvt.is_processed">Confirm</span>
                <span v-if="cEvt.is_processed">Undo</span>
              </button>
              <button type="submit" class="btn btn-sm btn-danger" @dblclick.prevent="deleteEvent" style="margin-right: 0 !important">
                <i class="icmn-bin" aria-hidden="true"></i> Delete
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="btn right" @click="setEvent(evtIndex - 1)" :class="{ disabled: evtIndex === 0 }"><i class="fa fa-arrow-right"></i></div>
    </div>
    <div class="events-cal">
      <input v-if="hasNavigator" type="text" name="chart-pos" class="form-control margin-left-10">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    serviceId: {
      type: Number|String,
    },
    date_format: {
      type: String,
    },
    time_format: {
      type: String,
    },
    token: {
      type: String,
    },
    hasNavigator: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      events: [],
      evtIndex: 0,
      totalEvents: 0,
      lastPage: 1,
      currentPage: 1,
      isLoading: true
    }
  },

  mounted() {
    this.getEvents().then((res) => {
      this.events = res.data.length ? res.data : false
      if (this.events) document.dispatchEvent(new CustomEvent("events.ready"));

      this.lastPage = res.last_page;
      this.totalEvents = res.total;
      this.isLoading = false;
      if (window.graphLoaded) {
        this.onGraphLoaded();
      } else {
        const self = this;
        document.addEventListener('graphloaded', () => self.onGraphLoaded())
      }
    });
  },
  methods: {
    formatTime(evt) {
      const offs = evt.service && evt.service.request ? evt.service.request.timezone : 0;
      return moment(Number(evt.sent_at_timestamp)).utcOffset(offs).format(`${this.date_format} ${this.time_format}`);
    },
    deleteEvent() {
      const formData = new FormData();
      formData.append('_method', 'DELETE');
      formData.append('_token', this.token);
      formData.append('no_redirect', 'true');
      const id = this.cEvt.id;
      --this.totalEvents;
      this.events.splice(this.evtIndex, 1);
      this.quickView();
      $.ajax({
        url: `/event/${id}`,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json'
      })
    },
    setEvent(i) {
      if (i < 0 || i >= this.totalEvents) return;

      if (i >= this.events.length) {
        this.getEvents(this.currentPage + 1).then((res) => {
          this.events = this.events.concat(res.data);
          this.evtIndex = i;
          this.quickView();
        })
      } else {
        this.evtIndex = i;
        this.quickView();
      }
      console.log(this._data);
    },
    quickView() {
      if (!this.cEvt) return;
      const event_time = this.cEvt.sent_at_timestamp;
      $('#graphdiv').highcharts().xAxis[0].setExtremes(event_time - 4000, event_time + 4000);
    },
    processEvent() {
      console.log(this.cEvt, this.events[this.evtIndex]);

      const status = !this.cEvt.is_processed;
      const eventId = this.cEvt.id;

      $.post(`/event/${eventId}/process`, { status }, () => {
        this.cEvt.is_processed = status;
        this.setEvent(this.evtIndex + 1)
      });
    },
    getEvents(page) {
      if (!page) page = 1;
      return new Promise(resolve => {
        $.ajax({
          type: 'get',
          url: `/event/fetch/${this.serviceId}?page=${page}`,
          success: (res) => {
            resolve(res);
          }
        });
      })
    },
    onGraphLoaded() {
      const self = this;
      setTimeout(() => {
        if (self.cEvt) {
          self.quickView();
        } else {
          $('#graphdiv').highcharts().xAxis[0].setExtremes(window.chart_end - 8000, window.chart_end);
        }
      }, 500)
    }
  },
  computed: {
    cEvt() {
      return this.events ? this.events[this.evtIndex] : null;
    }
  }
}
</script>

<style>
.events-container {
  display: flex;
  position: relative;
  align-items: center;
}
.events-cal {
  flex-basis: content;
  margin-left: auto;
}
.events-row {
  display: flex;
  align-items: center;
  position: relative;
  flex-grow: 1;
}
.events-row > .btn {
  width: 50px;
  flex-shrink: 0;
  color: #01a8fe;
}
.events-row .events-data {
  flex-grow: 1;
  margin: 0 10px;
  display: flex;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.01);
}
.events-row .events-data .cell {
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}
.events-row .events-data .cell:not(:last-child):not(:first-child) {
  flex-grow: 1;
}
.events-row .events-data .cell:nth-child(odd) {
  background: rgba(1, 168, 254, 0.1);
}
.events-row .events-data .cell:nth-child(even) {
  background: rgba(0, 0, 0, 0.01);
}
.events-row .events-data .cell .value {
  display: flex;
  align-items: center;
  flex-grow: 1;
}
</style>
